/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'check': {
    width: 16,
    height: 16,
    viewBox: '0 0 32 28',
    data: '<path pid="0" d="M30.2.4c.3-.4 1-.5 1.4-.1.4.3.5 1 .1 1.4l-21.5 26c-.4.4-1 .5-1.4.1l-.1-.1L.2 17.3c-.3-.4-.3-1.1.1-1.4.4-.3 1.1-.3 1.4.1l7.7 9.4L30.2.4z"/>'
  }
})
